// extracted by mini-css-extract-plugin
export var tickerHolder = "Ticker-module--tickerHolder--6f2cb";